const config = {
	authURL: process.env.VUE_APP_QUICKBOOKS_AUTH_URL
}

export default config
